// import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

const MySiteMeta = () => {
  const { site } = useStaticQuery(siteMetadataQuery)
  const siteMeta = site.siteMetadata
//   console.log(siteMeta)
  return siteMeta
}

const siteMetadataQuery = graphql`
  query MySiteMetadataQuery {
    site {
      ...MySiteMetadata
    }
  }
`
export default MySiteMeta